import React from "react";
import styled, { useTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitterSquare,
  faFacebookSquare,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { OutboundLinkStyles } from "./LinkStyles";
import { MaxWidthContainer } from "./MaxWidthContainer";

const Footer = (): JSX.Element => {
  const theme = useTheme();

  const socialIconColor = theme.colours.midBlue;

  return (
    <FooterContainer>
      <MaxWidthContainer
        wideLayout
        style={{
          justifyContent: "center",
        }}
      >
        <SocialIconsContainer>
          <OutboundLinkStyles
            href="https://twitter.com/bluebeckstudios"
            aria-label="Clickable link to the Blue Beck Twitter page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faTwitterSquare}
              style={{ ...IconStyles, color: socialIconColor }}
            />
          </OutboundLinkStyles>
          <OutboundLinkStyles
            href="https://www.facebook.com/BlueBeckLtd"
            aria-label="Clickable link to the Blue Beck Facebook page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faFacebookSquare}
              style={{ ...IconStyles, color: socialIconColor }}
            />
          </OutboundLinkStyles>
          <OutboundLinkStyles
            href="https://www.linkedin.com/company/blue-beck-ltd./"
            aria-label="Clickable link to the Blue Beck LinkedIn page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faLinkedin}
              style={{ ...IconStyles, color: socialIconColor }}
            />
          </OutboundLinkStyles>
        </SocialIconsContainer>
      </MaxWidthContainer>
    </FooterContainer>
  );
};

const IconStyles = {
  width: "1.5rem",
  height: "1.5rem",
  maxWidth: "40px",
  maxHeight: "40px",
  margin: "0 5px",
};
const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6rem;
  @media (max-width: ${(props) => props.theme.screenSize.l}px) {
    height: 4rem;
  }
`;
const SocialIconsContainer = styled.div`
  display: flex;
  margin-bottom: 10px; /* Remove this margin-bottom completely when Careers link is used in header */
  a {
    line-height: 0;
    &:hover {
      cursor: pointer;
    }
  }
`;

export default Footer;
